
import React, { useEffect, useState } from 'react';
import { Row, Col, Badge } from 'reactstrap';
import './styles.css';
import LeaveRequests from './LeaveRequests';
import CorrectionRequests from './CorrectionRequests';
import TeamReport from './TeamReport';
import IssueTracker from './IssueTracker';
import MessageBox from './MessageBox';
import ProjectAllocation from './ProjectAllocation';
import Reports from './Reports';
import AddTimeline from '../timeLineSection/addTimeline/AddTimeline';
import DashboardTimelineSection from '../DashboardTimelineSection';
import { ColorRing } from 'react-loader-spinner';

const ManagerDashboard = ({last_ten_leave , last_ten_correction, last_ten_issues, show_loader}) => {

     //   <===============================Header data start=======================================>
      const [dateTime, setDateTime] = useState('');
      const [greeting, setGreeting] = useState("Good Morning,");

    
      const formatDateTime = () => {
        const now = new Date();
        return now.toLocaleString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        });
      };
    
      useEffect(() => {
        setDateTime(formatDateTime());
        const intervalId = setInterval(() => {
          setDateTime(formatDateTime());
        }, 60000);
        return () => clearInterval(intervalId);
      }, []);
    
      useEffect(() => {
        const hour = new Date().getHours();
        setGreeting(
          hour >= 5 && hour < 12 ? "Good Morning," :
            hour >= 12 && hour < 17 ? "Good Afternoon," :
              "Good Evening,"
        );
      }, [dateTime]);
      //   <===============================Header data start=======================================>
  return (
    
    <div className="manager-dashboard">
  {show_loader ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: '999'
                          }}
                          aria-labelledby='contained-modal-title-vcenter'
                        >
                          <div className='loader-container'>
                            <ColorRing
                              visible={true}
                              height='160'
                              width='160'
                              ariaLabel='blocks-loading'
                              wrapperStyle={{}}
                              wrapperClass='blocks-wrapper'
                              colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                            />
                          </div>
                        </div>
                      ) : null}
       {/* <=========================Header Start===========================*/}
       {/* <div className="header-wrapper">
        <div className="header-container">
          <div className="profile-section">
            <img
              src="https://randomuser.me/api/portraits/men/9.jpg"
              alt="profile"
              className="profile-image"
            />
            <div className="online-indicator" />
          </div>

          <div className="greeting-section">
            <h2 className="greeting-text">
              {greeting} {toTitleCase(firstname)}!
            </h2>
            <p className="welcome-text">
              {toTitleCase(designation)} , {toTitleCase(role)}
            </p>
            <p className="welcome-text">
              {toTitleCase(location)}
            </p>
          </div> */}

          {/* <div className="time-section">
                    <FaRegClock className="clock-icon" />
                    <span className="time-text">{dateTime}</span>
                </div> */}
                 {/* <div className="time-section">
          <FaUsers className="mr-2" />
          <span className="mr-3">Team: 24 members</span>
          <Badge color="success" className="mr-2">Present: 18</Badge>
          <Badge color="warning" className="mr-2">Leave: 4</Badge>
          <Badge color="danger">Absent: 2</Badge>
        </div>

          <div className="bg-decoration" />
        </div>
      </div> */}
      {/* <=========================Header Card End===========================*/}


      <Row>
        <Col md={6} lg={12} className="mb-4" >
          <LeaveRequests last_ten_leave={last_ten_leave}/>
        </Col>

        <Col md={6} lg={6} className="mb-4">
          <CorrectionRequests last_ten_correction={last_ten_correction}/>
        </Col>

        {/* <Col md={6} lg={4} className="mb-4">
          <TeamReport />
        </Col> */}

        <Col md={6} lg={6} className="mb-4">
          <IssueTracker last_ten_issues={last_ten_issues}/>
        </Col>

        <Col md={12} lg={12} className="mb-4">
          <MessageBox />
        </Col>

        <Col md={12} className="mb-4">
          <Reports />
        </Col>

        <Col md={6} lg={12} className="mb-4">
          <ProjectAllocation />
        </Col>
      </Row>
    </div>
  );
};

export default ManagerDashboard;